module.exports = __webpack_public_path__ + "static/img/03.caebdb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/03/03.jpg
// module id = UH1o
// module chunks = 0